import React from "react";
import { Subscribe } from "unstated";
import SrpContainer from "../../containers/SrpContainer";
import { post } from "venuescanner-js/services/api";
import { popup } from "venuescanner-js/vanilla/components/popup";
const flagPlaceForMetrics = (placeId, andChildren = false) => {
  // console.log(placeId)
  popup.new("<div>Updating...</div>", { loading: true });
  post(`/admin/place/metricflag/${placeId}`, { placeId, andChildren })
    .then(({ updated }) => {
      popup.show(
        `<div>Updated ${updated} location${updated === 1 ? "" : "s"}</div>`,
        { loading: false, success: true, closable: true }
      );
    })
    .catch((e) => {
      popup.show(`<div>${e.message || e}</div>`, {
        loading: false,
        success: false,
        closable: true,
      });
    });
};

const AdminOptions = ({ isAdmin, place }) => {
  return isAdmin && place && place.id ? (
    <div className="srp-admin-options">
      <button
        className="asLink"
        type="button"
        onClick={() => {
          flagPlaceForMetrics(place.id);
        }}
      >
        Flag {place.name} for metrics
      </button>{" "}
      &amp;{" "}
      <button
        className="asLink"
        type="button"
        onClick={() => {
          flagPlaceForMetrics(place.id, true);
        }}
      >
        sub-locations
      </button>
    </div>
  ) : null;
};

const AdminOptionsContainer = () => (
  <Subscribe to={[SrpContainer]}>
    {({
      isAdmin,
      state: {
        data: { place_model },
      },
    }) => {
      // console.log(place_model)
      return <AdminOptions isAdmin={isAdmin} place={place_model} />;
    }}
  </Subscribe>
);

export default AdminOptionsContainer;
